import { useState, useEffect, Dispatch, SetStateAction } from "react";
import { SwiperClass, SwiperRef } from "swiper/react";
import VideoGalleryService from "./VideoGalleryService";
import { IDeviceStateControllerReturn } from "../../../services/devicestate/DeviceStateController";

interface IProps {
  dsc: IDeviceStateControllerReturn;
}

export interface IVideoGalleryControllerReturn {
  //states
  currentIndex: number;
  setSwiperInstance: Dispatch<SetStateAction<SwiperClass | null>>;
  refSwiper: SwiperRef | null; setRefSwiper: Dispatch<SetStateAction<SwiperRef | null>>;
  refSwiperWrapper: HTMLDivElement | null; setRefSwiperWrapper: Dispatch<SetStateAction<HTMLDivElement | null>>;
  refSlideWrapper: HTMLDivElement | null; setRefSlideWrapper: (refSlideWrapper: HTMLDivElement | null) => void;
  slidesPerView: number;
  render: number;
  //functions
  handleSlideChange: (swiper: SwiperClass) => void;
}

export const VideoGalleryController = (props: IProps): IVideoGalleryControllerReturn => {

  //hint: workaround to wait until resize refSlideWrapper ->  create audioplaybutton
  const [render, setRender] = useState<number>(0);
  const [refSwiper, setRefSwiper] = useState<SwiperRef | null>(null);
  const [refSwiperWrapper, setRefSwiperWrapper] = useState<HTMLDivElement | null>(null);
  const [slidesPerView, setSlidesPerView] = useState<number>(0);
  
  //slideWrapper
  const setRefSlideWrapper = (refSlideWrapper : HTMLDivElement | null) => {
    if(refSlideWrapper == undefined || refSlideWrapper == null) return;
    if(refSlideWrapper?.offsetHeight <= 1) return;
    if(refSlideWrapper?.offsetWidth <= 1) return;
    //VideoGalleryService.itemsSize[0] = refSlideWrapper?.offsetWidth;
    //VideoGalleryService.itemsSize[1] = refSlideWrapper?.clientHeight;
    setSlidesPerViewIntern(refSlideWrapper?.offsetWidth)
    _setRefSlideWrapper(refSlideWrapper);
    //setRender(render+1)
  }
  const [refSlideWrapper, _setRefSlideWrapper] = useState<HTMLDivElement | null>(null);

  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass | null>(null);
  useEffect(() => {
    if (swiperInstance == null) return;
    setCurrentIndex(swiperInstance.activeIndex)
  }, [swiperInstance])

  const handleSlideChange = (swiper: SwiperClass) => {
    setCurrentIndex(swiper.activeIndex);
  };

  useEffect(() => {
   setSlidesPerViewIntern()
  }, [props.dsc.isLandscape])

  const setSlidesPerViewIntern = (clientWidth?: number) => {

    //const itemWidth = refSlideWrapper?.offsetWidth?refSlideWrapper?.offsetWidth:320
    // const itemWidth = 320
    // const w = clientWidth
    // if (w == undefined) return;

    // let items = Math.floor(w / itemWidth)
    // if(props.dsc.isMobile) {
    //   setSlidesPerView(1);
    //   return;
    // }
    // if(items == slidesPerView) return
    // setSlidesPerView(items)
  }


  return {
    //states
    currentIndex,
    setSwiperInstance,
    //setCurrentVideo,
    refSwiperWrapper, setRefSwiperWrapper,
    refSwiper, setRefSwiper,
    refSlideWrapper, setRefSlideWrapper,
    slidesPerView,
    render,
    //functions
    handleSlideChange,
    //stopCurrentVideo,

  }
}  